// extracted by mini-css-extract-plugin
export var video = "styles-module--video--qXWaQ";
export var videoItem = "styles-module--video-item--Q1qwx";
export var videos = "styles-module--videos--cS7qG";
export var videosContainer = "styles-module--videos-container--vl7FG";